import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  CardContent,
  Stack,
  TablePagination,
  CircularProgress,
  Paper,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  TextField,
  InputAdornment,
} from "@mui/material";
import TableCell from "@mui/material/TableCell";
import { styled } from "@mui/system";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import HRNavbar from "../../../HR/HRNavbar";
import Footer from "../../../../Footer";

// Apne FormViewModal component ko import karein
import FormViewModal from "./FormViewModal";
import { API_URL } from "../../../Config/api";



const ProfessionalDetailsCard = styled(Paper)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "54px",
  borderRadius: "10px",
  padding: "0 10px",
  "&:hover": { backgroundColor: "#F7F7F7" },
});

function PackageManagementList() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Search state
  const [searchQuery, setSearchQuery] = useState("");

  // Modal ke states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState(null);
  const [viewLoading, setViewLoading] = useState(null);

  // Dropdown Menu ke states
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentFormsList, setCurrentFormsList] = useState([]);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/packages/FormAssignedPackages/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setPackages(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewFormClick = async (formId) => {
    if (!formId) {
      alert("Form ID is missing!");
      return;
    }

    setViewLoading(formId);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_URL}/packages/preview_closure_form/`,
        {
          params: { form_id: formId },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.data && response.data.data) {
        setModalFormData(response.data.data);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to fetch form preview.");
    } finally {
      setViewLoading(null);
    }
  };

  const handleViewButtonClick = (event, services) => {
    const availableForms = services.filter((s) => s.form_id);

    if (availableForms.length === 1) {
      handleViewFormClick(availableForms[0].form_id);
    } else if (availableForms.length > 1) {
      setAnchorEl(event.currentTarget);
      setCurrentFormsList(availableForms);
    }
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentFormsList([]);
  };

  const handleSelectFormFromMenu = (formId) => {
    handleCloseMenu();
    handleViewFormClick(formId);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const filteredPackages = packages.filter((pkg) =>
    pkg.package_name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <HRNavbar />
      <Box sx={{ flexGrow: 1, mt: 14.6, ml: 1, mr: 1, mb: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2, mx: "10px" }}
        >
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
            }}
            color="text.secondary"
          >
            PACKAGE MANAGEMENT LIST
          </Typography>

          <TextField
            variant="outlined"
            size="small"
            placeholder="Search Packages..."
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{
              width: "300px",
              backgroundColor: "white",
              borderRadius: "8px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        </Stack>

        {/* Height kam kar di gayi hai (42vh) */}
        <TableContainer
          sx={{ height: "42vh", minHeight: "300px", overflowY: "auto" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <ProfessionalDetailsCard
                  style={{
                    background: "#A5D6A7",
                    color: "#000",
                    borderRadius: "8px 10px 0 0",
                    padding: "0 10px",
                  }}
                >
                  <CardContent style={{ flex: 0.5 }}>
                    <Typography variant="subtitle2" fontWeight="600">
                      Sr. No
                    </Typography>
                  </CardContent>
                  <CardContent style={{ flex: 2 }}>
                    <Typography variant="subtitle2" fontWeight="600">
                      Package Name
                    </Typography>
                  </CardContent>
                  <CardContent style={{ flex: 1.5 }}>
                    <Typography variant="subtitle2" fontWeight="600">
                      Cost (₹)
                    </Typography>
                  </CardContent>
                  <CardContent style={{ flex: 1 }}>
                    <Typography variant="subtitle2" fontWeight="600">
                      Duration
                    </Typography>
                  </CardContent>
                  <CardContent style={{ flex: 1 }}>
                    <Typography variant="subtitle2" fontWeight="600">
                      Status
                    </Typography>
                  </CardContent>
                  <CardContent style={{ flex: 1 }}>
                    <Typography variant="subtitle2" fontWeight="600">
                      Action
                    </Typography>
                  </CardContent>
                </ProfessionalDetailsCard>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  {/* Empty state ki height bhi 30vh kar di hai */}
                  <TableCell
                    colSpan={6}
                    align="center"
                    style={{ height: "30vh", borderBottom: "none" }}
                  >
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : filteredPackages.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    style={{ height: "30vh", borderBottom: "none" }}
                  >
                    <Typography variant="subtitle1" color="text.secondary">
                      {searchQuery
                        ? `No packages found matching "${searchQuery}"`
                        : "No data found"}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredPackages
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <TableRow key={item.package_id}>
                      <ProfessionalDetailsCard style={{ padding: "0 10px" }}>
                        <CardContent style={{ flex: 0.5 }}>
                          <Typography variant="subtitle2">
                            {page * rowsPerPage + index + 1}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 2 }}>
                          <Typography variant="subtitle2">
                            {item.package_name}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1.5 }}>
                          <Typography variant="subtitle2">
                            ₹{item.package_cost}
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1 }}>
                          <Typography variant="subtitle2">
                            {item.duration} Days
                          </Typography>
                        </CardContent>
                        <CardContent style={{ flex: 1 }}>
                          <Typography
                            variant="subtitle2"
                            color={item.status ? "green" : "red"}
                          >
                            {item.status ? "Active" : "Inactive"}
                          </Typography>
                        </CardContent>
                        <CardContent
                          style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            variant="outlined"
                            size="small"
                            disabled={
                              !item.service_details ||
                              item.service_details.filter((s) => s.form_id)
                                .length === 0
                            }
                            onClick={(e) =>
                              handleViewButtonClick(e, item.service_details)
                            }
                          >
                            {item.service_details?.some(
                              (s) => s.form_id === viewLoading,
                            ) ? (
                              <CircularProgress size={20} />
                            ) : (
                              "View Form"
                            )}
                          </Button>
                        </CardContent>
                      </ProfessionalDetailsCard>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={filteredPackages.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Footer />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 4,
          sx: {
            mt: 1,
            minWidth: 280,
            borderRadius: "10px",
            padding: "4px 0",
          },
        }}
      >
        <Box sx={{ px: 2, py: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight="bold"
          >
            AVAILABLE FORMS
          </Typography>
        </Box>
        <Divider sx={{ mb: 1 }} />
        {currentFormsList.map((service, index) => (
          <MenuItem
            key={index}
            onClick={() => handleSelectFormFromMenu(service.form_id)}
            sx={{
              py: 1,
              px: 2,
              "&:hover": { backgroundColor: "#F4F6F8" },
            }}
          >
            <ListItemIcon>
              <DescriptionOutlinedIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body2" fontWeight="600" color="text.primary">
                {service.form_name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {service.service_name}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>

      <FormViewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        formData={modalFormData}
      />
    </div>
  );
}

export default PackageManagementList;
